import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type UiSignalState = string | boolean;
type ReaderInfoState = string | Record<string, unknown>;
type DeviceSearchState = string;

/**
 * UiSignalsStateService
 * --------------------------------------------------------------------
 * Modal / mode / popup / device-search UI-coordination streams.
 * Extracted from the retained section of the legacy `ApiService`.
 */
@Injectable({ providedIn: "root" })
export class UiSignalsStateService {
  // --- Environment scratch pad (was on ApiService) ------------------
  envURL: unknown;
  keyNumber: unknown;

  // --- Cross-cutting selection state --------------------------------
  private selectedFeaturesArray: unknown[] = [];

  // --- Modal control -----------------------------------------------
  readonly selectedModal = new BehaviorSubject<string>("");
  readonly getSelectedModal: Observable<string> = this.selectedModal.asObservable();
  readonly configMethod = new BehaviorSubject<string>("");
  readonly getConfigMethod: Observable<string> = this.configMethod.asObservable();
  readonly isDisable = new BehaviorSubject<string>("");
  readonly makeDisable: Observable<string> = this.isDisable.asObservable();
  readonly Reload = new BehaviorSubject<string>("");
  readonly getReload: Observable<string> = this.Reload.asObservable();
  readonly closeIt = new BehaviorSubject<string>("");
  readonly closeModal: Observable<string> = this.closeIt.asObservable();
  readonly information = new BehaviorSubject<ReaderInfoState>("");
  readonly getReaderInfo: Observable<ReaderInfoState> = this.information.asObservable();

  // --- Modes / devices --------------------------------------------
  readonly modes = new BehaviorSubject<string>("");
  readonly getmodes: Observable<string> = this.modes.asObservable();
  readonly callConfig = new BehaviorSubject<string>("");
  readonly getConfigMode: Observable<string> = this.callConfig.asObservable();
  readonly removeSelect = new BehaviorSubject<string>("");
  readonly getSelect: Observable<string> = this.removeSelect.asObservable();
  readonly devices = new BehaviorSubject<DeviceSearchState>("");
  readonly searchDevices: Observable<DeviceSearchState> = this.devices.asObservable();
  readonly clear = new BehaviorSubject<string>("");
  readonly clearFilterDevices: Observable<string> = this.clear.asObservable();

  // --- Device-select popups ----------------------------------------
  readonly closeSelectDevicePopup = new BehaviorSubject<string>("");
  readonly checkCloseSelectDevicePopup: Observable<string> =
    this.closeSelectDevicePopup.asObservable();
  readonly closeConfigPopup = new BehaviorSubject<string>("");
  readonly checkCloseConfigPopup: Observable<string> = this.closeConfigPopup.asObservable();

  // --- Setters ----------------------------------------------------
  setSelectedFeaturesArray(features: unknown[]): void {
    this.selectedFeaturesArray = features;
  }
  getSelectedFeaturesArray(): unknown[] {
    return this.selectedFeaturesArray;
  }

  sendSelectedModala(data: string): void {
    this.selectedModal.next(data);
  }
  callConfigMethod(data: string): void {
    this.configMethod.next(data);
  }
  disableBtn(data: string): void {
    this.isDisable.next(data);
  }
  dontReload(data: string): void {
    this.Reload.next(data);
  }
  modalClose(data: string): void {
    this.closeIt.next(data);
  }
  readerInfo(data: ReaderInfoState): void {
    this.information.next(data);
  }
  sendModes(data: string): void {
    this.modes.next(data);
  }
  configModeRefresh(data: string): void {
    this.callConfig.next(data);
  }
  removeModes(data: string): void {
    this.removeSelect.next(data);
  }
  searchDevice(data: DeviceSearchState): void {
    this.devices.next(data);
  }
  clearFilter(data: string): void {
    this.clear.next(data);
  }
  sendCloseSelectDevicePopup(data: string): void {
    this.closeSelectDevicePopup.next(data);
  }
  sendCloseConfigPopup(data: string): void {
    this.closeConfigPopup.next(data);
  }
}
